<template>
  <v-dialog
      class="hide-on-print"
      v-model="innerOpen"
      persistent
      width="800">

    <v-card class="hide-on-print">
      <v-toolbar color="blue darken-3" dark>
        <v-toolbar-title>Exempt cost</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-form class="pa-2" lazy-validation ref="manualRef">
          <v-layout row wrap>
            <v-flex xs6>
              <v-select
                  :items="exemptSubjects"
                  v-model="paymentData.subject"
                  :rules="[rules.required]"
                  label="Exempt Cost on"
                  outlined
                  class="mr-2"/>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                  label="Amount (USD) *"
                  outlined
                  type="number"
                  v-model="paymentData.amount"
                  :rules="[rules.required]"
                  :error-messages="errorMessage"
                  @input="compareCost"
                  onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  label="Reason for exemption *"
                  outlined
                  v-model="paymentData.remarks"
                  :rules="[rules.required]"
              />
            </v-flex>
            <v-flex xs12>
              <multiple-file-upload v-model="paymentData.files"
                                    label="Files (If any)"
              />
            </v-flex>


          </v-layout>
        </v-form>

      </v-card-text>
      <v-divider style="margin-top:31px;"/>
      <v-card-actions>
        <v-spacer/>
        <v-btn
            @click="cancel"
            class="white--text"
            color="red darken-3"
        >Cancel
        </v-btn>
        <v-btn
            @click="save"
            class="white--text"
            color="blue darken-3"
        >Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {validationMixin} from "../../mixins/validationMixin";
import {VERSIONED_API_URL} from "../../config/config";
import Http from "axios"
import MultipleFileUpload from "../MultipleFileUpload";

export default {
  name: "CostExemptionDialog",
  components: {MultipleFileUpload},
  props: ['value', 'url', 'maxAmount', 'paymentDetail', 'type'],
  mixins: [validationMixin],
  data() {
    return {
      paymentData: {
        subject: this.type === 'trekking' ? "trekking_fee" : "visa_fee",
        visa_fee: this.type === 'trekking' ? 0 : this.paymentDetail.amount + this.paymentDetail.transfer_cost + this.paymentDetail.late_stay_cost,
        late_fee:this.type ==='trekking' ? 0 : this.paymentDetail.late_stay_cost,
        penalty: this.type === 'trekking' ? 0 : this.paymentDetail.border_penalty + this.paymentDetail.penalty_cost,
      },
      innerOpen: false,
      errorMessage: '',
      exemptSubjects: [{
        text: "Visa Fee",
        value: "visa_fee",
      },
        {
          text: "Late Fee",
          value: "late_fee"
        },
        {
          text: "Penalty",
          value: "penalty_fee"
        },
        {
          text: "Trekking",
          value: "trekking_fee"
        },
        {
          text: "Both (Visa and Penalty fee)",
          value: "both"
        }],
    }
  },
  watch: {
    value(input) {
      this.innerOpen = input;
    },
    innerOpen(value) {
    }
  },
  mounted() {
    if (this.value) {
      this.innerOpen = this.value;
    }
  },
  methods: {
    async save() {
      if (this.$refs.manualRef.validate()) {
        try {
          let exemptSubjectType = this.paymentData.subject;
          let amount = Number(this.paymentData.amount);
          if ((exemptSubjectType === 'visa_fee' && amount > Number(this.paymentData.visa_fee)) || (exemptSubjectType === 'late_fee' && amount > Number(this.paymentData.late_fee)) ||
              (exemptSubjectType === 'penalty_fee' && amount > Number(this.paymentData.penalty)) ||
              (exemptSubjectType === 'trekking_fee' && amount > Number(this.maxAmount)) ||
              (exemptSubjectType === 'both' && amount > Number(this.maxAmount))) {
            this.$store.commit('Notification/showError', 'Cannot exempt cost . The amount is greater than the actual amount ');
            return;
          }

          const formData = new FormData();
          formData.append('amount', this.paymentData.amount);
          formData.append('remarks', this.paymentData.remarks);
          formData.append('subject', exemptSubjectType);


          const response = await Http.post(VERSIONED_API_URL + '/' + this.url, formData);
          this.$store.commit('Notification/showSuccess', response.data.message);
          this.paymentData = {};
          this.$emit('input', false);
          this.innerOpen = false;
          this.$emit('exempted', response.data.amount)
        } catch (e) {
          this.$store.commit('Notification/showError', e.response.data.message);
        }
      }
    },

    compareCost() {
      let exemptSubjectType = this.paymentData.subject;
      let amount = this.paymentData.amount;
      if ((exemptSubjectType === 'visa_fee' && amount > Number(this.paymentData.visa_fee)) || (exemptSubjectType === 'late_fee' && amount > Number(this.paymentData.late_fee)) ||
          (exemptSubjectType === 'penalty_fee' && amount > Number(this.paymentData.penalty)) ||
          (exemptSubjectType === 'both' && amount > Number(this.maxAmount)))
        this.errorMessage = "Entered amount exceed the total amount under selected subject";
      else
        this.errorMessage = "";
    },

    cancel() {
      this.paymentData = {};
      this.innerOpen = false;
      this.$emit('input', false)
    }
  }
}
</script>

